const FORMULA_START = /^[=+\-@\t\r]/;
const NEEDS_QUOTES = /[",\r\n]/;
const LINE_BREAK = '\r\n';
const BYTE_ORDER_MARK = '\uFEFF';

const cellText = (value: unknown): string => {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};

const isPlainNumber = (value: unknown): boolean =>
  typeof value === 'number' && Number.isFinite(value);

const escapeCell = (value: unknown): string => {
  const text = cellText(value);
  const safe =
    !isPlainNumber(value) && FORMULA_START.test(text) ? `'${text}` : text;
  return NEEDS_QUOTES.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export const toCsv = (
  columns: Array<{ field: string; label: string }>,
  rows: Array<Record<string, unknown>>,
): string => {
  const header = columns.map(column => escapeCell(column.label)).join(',');
  const lines = rows.map(row =>
    columns.map(column => escapeCell(row[column.field])).join(','),
  );
  return [header, ...lines].join(LINE_BREAK);
};

export const downloadCsv = (fileName: string, csv: string): void => {
  const url = URL.createObjectURL(
    new Blob([BYTE_ORDER_MARK, csv], { type: 'text/csv;charset=utf-8' }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
};
